
import {
  Component,
  Mixins,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { tSearch } from '@/components/Search/index';
import { State, Mutation } from 'vuex-class';
import { ITABLECOLCONF } from '@/types/base.d';
import { IPackage } from '@/types/org.d';
import api from '@/api/org';
import pageMixin from '@/views/Home/mixins/pageMixin';
import packageModal from '../form/course/index.vue';
import SearchForm from './components/searchForm.vue';

@Component({
  components: {
    Pagination,
    packageModal,
    tSearch,
    SearchForm,
  },
})
export default class Account extends Mixins(pageMixin) {
  @State(state => state.org.curCompRefresh) curCompRefresh!: boolean;

  @Mutation('org/SET_ORG_COMPENT_REFRESH') handleCloseRerfesh!: Function;

  private loading: Boolean = true;

  private tList: any = [];

  private orgId: string = '';

  private title: string = '';

  private form: IPackage = {
    coursePid: '',
    orgPid: '',
    price: 500,
    remark: '',
  };

  private visible: boolean = false;

  private searchValue: string = '';

  public $refs!: {
    searchForm: SearchForm;
  }

  @Prop({
    required: true,
  }) chargeType!: string;

  private column: Array<ITABLECOLCONF> = [
    {
      label: '名称',
      prop: 'courseTitle',
      align: 'center',
      tooltip: true,
    },
    {
      label: '课程服务费',
      prop: 'servicePrice',
      align: 'center',
      tooltip: true,
      width: '100px',
    },
    {
      label: '状态',
      custom: true,
      prop: 'courseStatus',
      align: 'center',
      width: '100px',
      tags: [{
        value: '1',
        type: 'warning',
        label: '已停用',
      }, {
        value: '0',
        type: 'success',
        label: '已启用',
      }],
    },
    {
      label: '创建时间',
      align: 'center',
      prop: 'createTime',
      minWidth: '100px',
      width: '200px',
      tooltip: true,
    },
    {
      label: '操作',
      custom: true,
      minWidth: '80',
      align: 'center',
      maxBtn: 2,
      btnList: [
        {
          title: '编辑',
          name: '/org/operate/course:update',
          icon: 'edit',
          type: 'info',
          callback: this.handleCourse,
          log: {
            name: '机构信息 - 课包记录 - 编辑',
            component: 'org/operate/table/course',
          },
        },
        {
          title: '停用',
          name: '/org/operate/course:status',
          icon: 'shield',
          type: 'info',
          handleType: (row: any) => {
            switch (row.courseStatus) {
              case 0: return 'success';
              case 1: return 'warning';
              default: return 'warning';
            }
          },
          handleTitle: (row: any) => {
            switch (row.courseStatus) {
              case 0: return '停用';
              case 1: return '启用';
              default: return '启用';
            }
          },
          callback: this.handleCourseStatus,
          log: {
            name: '机构信息 - 课包记录 - 启用/停用',
            component: 'org/operate/table/course',
          },
        },
      ],
    },
  ];

  mounted() {
    this.getData();
  }

  handleSearchChange(v: string) {
    this.getData({ title: v });
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索提交事件
   */
  handleAdvancedSearch() {
    const form: any = this.$refs.searchForm.getFormData();
    const params: any = {
      title: form.title,
      tid: form.tid,
      version: form.version,
    };
    const tid: any = []
    params.tid = params.tid.forEach((item: any) => {
      tid.push(item[1]);
    })
    params.tid = tid.toString()
    const flag: boolean = Object.values(params).some((em: any) => em && em.length > 0);
    if (flag) this.getData(params);
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索普通搜索切换事件
   * @param { boolean } activate 是否切换
   */
  handleActivateChange(activate: boolean) {
    if (activate) {
      this.$refs.searchForm.setTitle(this.searchValue);
      this.searchValue = '';
    } else this.searchValue = this.$refs.searchForm.getFormData().title;
  }

  /**
   * @author liangyongmou
   * @desc 高级搜索清空按钮事件
   */
  handleAdvanceClear() {
    this.$refs.searchForm.handleClear();
    this.getData();
  }

  getData(params?: Object) {
    this.loading = true;
    this.page.params = params;
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
    console.log(data)
    api.getOrgCourseList(data, this.$route.params.pid || '').then((res: any) => {
      this.tList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /**
   * @author liangyongmou
   * @description 打开课包分配编辑
   * @param { any } row 行数据
   */
  handleCourse(row: any) {
    this.form = {
      courseTitle: row.courseTitle,
      pid: row.pid,
      coursePid: row.coursePid,
      orgPid: this.orgId,
      price: row.servicePrice,
      remark: row.remark,
    };
    this.title = '编辑课包分配';
    this.visible = true;
  }

  /**
   * @author liangyongmou
   * @description 改变课包状态
   * @param { any } row 行数据
   */
  handleCourseStatus(row: any) {
    this.confirm('你确认进行该操作吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      let status = 0;
      if (row.courseStatus === 0) status = 1;
      else if (row.courseStatus === 1) status = 0;
      api.courseStatus({ pid: Base64.encode(row.pid), status }).then(() => {
        close();
        this.getData();
        this.$log({
          title: '机构管理 - 课包停用/启用 - 确定',
          component: 'org/manage/course',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 课包停用/启用 - 取消',
      component: 'org/manage/course',
    }));
  }

  @Watch('curCompRefresh')
  handlePageRefrsh(v: boolean) {
    if (v) {
      this.handleCloseRerfesh(false);
      this.page.pageNo = 1;
      this.getData();
    }
  }


  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
